import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-documents',
  templateUrl: './documents.component.html',
  styleUrls: ['./documents.component.scss']
})
export class DocumentsComponent implements OnInit, OnChanges {
  @Input() public documents: any;
  @Input() public days: any;
  @Input() public pdf: any;
  isCollapsed: boolean[] = [];
  activeCollapses: number[] = [];
  uniqueCountryNames: string[] = [];
  pdfItems: string[] = [];

  constructor() { }

  ngOnInit(): void {
    this.recomputeData();
    if (Array.isArray(this.documents)) {
      this.isCollapsed = Array(this.documents.length).fill(true);
      if (this.isCollapsed.length > 0) {
        this.isCollapsed[0] = false;
      }
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.recomputeData();
    if (changes['documents'] && Array.isArray(this.documents)) {
      this.isCollapsed = Array(this.documents.length).fill(true);
      if (this.isCollapsed.length > 0) {
        this.isCollapsed[0] = false;
      }
    }
  }

  private recomputeData(): void {
    this.uniqueCountryNames = [];
    if (Array.isArray(this.days)) {
      for (let i = 0; i < this.days.length; i++) {
        const countryName = this.days[i]?.country_name;
        if (countryName && !this.uniqueCountryNames.includes(countryName)) {
          this.uniqueCountryNames.push(countryName);
        }
      }
    }

    this.pdfItems = [];
    if (Array.isArray(this.pdf)) {
      for (const countryName of this.uniqueCountryNames) {
        const url = this.getCountryLink(countryName);
        if (url) {
          this.pdfItems.push(url);
        }
      }
    }
  }

  toggleCollapse(index: number) {
    this.isCollapsed[index] = !this.isCollapsed[index];
    if (this.isCollapsed[index]) {
      // rimuove l'indice dal vettore activeCollapses quando il collapse è chiuso
      const i = this.activeCollapses.indexOf(index);
      if (i !== -1) {
        this.activeCollapses.splice(i, 1);
      }
    } else {
      // aggiunge l'indice al vettore activeCollapses quando il collapse è aperto
      this.activeCollapses.push(index);
    }
  }

  getCountryLink(countryName: string): string {
    let countryLink = this.pdf;
    console.log(countryLink);
    for (let i = 0; i < countryLink.length; i++) {
      if (countryName in countryLink[i]) {
        return countryLink[i][countryName];
      }    
    }
    
    return "";
  }

  returnTitle(url: string) {
    const title = url.substring(url.lastIndexOf('/') + 1);
    return title;
  }

}
